import MockTestCard from "../../../../../ReusableComponent/MockTestCard";

const mockTests = [
  {
    title: "GATE CSE Mock Test",
    details: "65 Questions • 3 hours",
    attempts: 1200,
  },
  {
    title: "Placement Aptitude Test",
    details: "50 Questions • 90 min",
    attempts: 2300,
  },
  {
    title: "Programming Contest Mock",
    details: "8 Questions • 2 hours",
    attempts: 800,
  },
  {
    title: "Technical Interview Prep",
    details: "30 Questions • 60 min",
    attempts: 1500,
  },
];

const MockTestSection = () => {
  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-5">
            <h3 className="fw-bold text-light">Practice Mock Tests</h3>
          </div>
          <div className="row mx-0">
            {mockTests.map((test, index) => (
              <MockTestCard
                key={index}
                title={test.title}
                details={test.details}
                attempts={test.attempts}
                onClick={() => alert(`Starting ${test.title}`)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MockTestSection;
